
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import BaseVue from "../../core/BaseVue";
import ProposalDisbursement from "@/models/porposal/proposalDisbursement.model";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import ProposalService from "@/services/porposal.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import fileService from "@/services/file.service";
import { ProposalState } from "@/enums/ProposalState";
import ProposalUserReport from "@/models/porposal/porposalUserReport.model";
import { ReportEvaluationState } from "@/enums/ReportEvaluationState";
import moment from "moment";
import PorposalDetail from "@/components/porposal-detail-component/detail.vue";
import { ProposalReportEvaluationType } from '@/enums/ProposalReportEvaluationType';
import { ReportEvaluationStateValidation } from '@/enums/ReportEvaluationStateValidation';
import PorposalUserReportEvaluations from '@/models/porposal/porposalUserReportEvaluations.model';
import BudgetExpenseService from '@/services/budgetExpense.service';
import ProposalBudgetItemExecution from '@/models/porposal/proposalBudgetItemExecution.model';

@Component({
  components: {
    DatePickerComponent,
    ResearchCenterBasicInformationComponent,
    UserBasicInformationComponent,
    PorposalDetail
  }
})
export default class ReportEvaluation extends BaseVue {
  file: any = null;
  showModal: boolean = false;
  loading: boolean = false;
  wasEvaluated: boolean = false;
  lastReport: ProposalUserReport = null;
  technicalScientistObservation: string = "";
  financialCharacterObservation: string = "";
  proposalService: ProposalService = new ProposalService();
  disbursement: ProposalDisbursement = new ProposalDisbursement();
  aprobado: ReportEvaluationState = ReportEvaluationState.Aprobado;
  pendiente: ReportEvaluationState = ReportEvaluationState.Pendiente;
  noAprobado: ReportEvaluationState = ReportEvaluationState.NoAprobado;
  total = {
    FONDOCYT: 0,
    TotalGeneral: 0,
    ContraPartida: 0
  };
  presupuestoCierre: number = 0;
  balanceReembolsarMescyt: number = 0;
  budgetEvaluation: ProposalReportEvaluationType = ProposalReportEvaluationType.BudgetEvaluation;
  reportEvaluation: ProposalReportEvaluationType = ProposalReportEvaluationType.ReportEvaluation;
  todasAprobados: ReportEvaluationStateValidation = ReportEvaluationStateValidation.TodasAprobados;
  hayNoAprobados: ReportEvaluationStateValidation = ReportEvaluationStateValidation.HayNoAprobados;
  model: any = null;
  isLoading: boolean = false;
  budgetExpenseService: BudgetExpenseService = new BudgetExpenseService();
  showModalEvaluacionesRealizadas: boolean = false;
  budgetExpenses: any = [];
  aprobadaFc = ProposalState.AprobadoFC;
  endProyectDate: Date = new Date();

  // budget
  totalAprovedFondocyt: number = 0;
  totalDisbursed: number = 0;
  TotalSpentSoFar: number = 0;
  totalAvailableInvestigator: number = 0;
  totalAvailableFondocyt: number = 0;
  // end budget


  async mounted() {
    this.getData();
  }

   calculateTotalAmountSpentByBudgetExpense(
    rows: Array<ProposalBudgetItemExecution>
  ) {
    return rows.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }

  async downloadFile(file: any) {
    if (file.document.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        file.document.id,
        file.document.originalName
      );
    else await fileService.download(file.document.id);
  }


  async showCurrentEvaluation(
    evaluations: PorposalUserReportEvaluations,
    data: any
  ) {
    if (
      evaluations.budgetItemEvaluations &&
      evaluations.budgetItemEvaluations.length > 0 &&
      data
    ) {
      this.loading = true;
      this.model = data;
      for (let i = 0; i < this.model.proposalBudgetItemsExecution.length; i++) {
        const proposalBudgetItemsExecution = this.model
          .proposalBudgetItemsExecution[i];
        proposalBudgetItemsExecution.budgetItemEvaluationUI = evaluations.budgetItemEvaluations.find(
          x =>
            x.proposalBudgetItemExecutionId == proposalBudgetItemsExecution.id
        );
        for (
          let y = 0;
          y <
          proposalBudgetItemsExecution.proposalBudgetSubItemsExecution.length;
          y++
        ) {
          const subItem =
            proposalBudgetItemsExecution.proposalBudgetSubItemsExecution[y];
            subItem.budgetSubItemEvaluationUI = proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations.find(
            x => x.proposalBudgetSubItemExecutionId == subItem.id
          );
        }
      }
      await this.getBudgetExpenses();
      this.loading = false;
      this.showModalEvaluacionesRealizadas = true;
    } else {
      this.operationNoAllowed("No se ha realizado evaluación");
    }
  }

  
  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response.filter(x =>
          this.model.porposalBudgetItems.some(y => y.budgetExpenseId == x.id)
        );
      }
    });
  }

  async getData() {
    this.loading = true;
    let reportId = Number(this.$route.params.rid);
    this.lastReport = await this.proposalService.getPorposalLastReportEvaluationById(
      reportId
    );
    this.model = this.lastReport;
    this.totalProyecto();
    this.presupuestoCierre = this.lastReport.closingBudget;
    if (this.lastReport.state == ProposalState.AprobadoFC) {
      this.wasEvaluated = true;
      this.disbursement.amount = this.lastReport.disbursementAmount;
      this.disbursement.disbursementDate = this.lastReport.disbursementDate;
      this.disbursement.deliveryDate = this.lastReport.deliveryDate;
      this.disbursement.requestDate = this.lastReport.requestDate;
      this.technicalScientistObservation = this.lastReport.technicalScientistObservation;
      this.financialCharacterObservation = this.lastReport.financialCharacterObservation;
    }
    this.loading = false;
  }

  async verDocument(data: any = null, isLastReport: boolean = false) {
    if (isLastReport) {
      if (data.projectEndDocument.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.projectEndDocument.id,
          data.projectEndDocument.originalName
        );
      else await fileService.download(data.projectEndDocument.id);
    } else {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
    }
  }
  public printCurriculunm() {
    window.print();
  }
  async verProposalDisbursementDocument(data: any = null) {
    if (
      data.proposalDisbursementDocument.contentType ==
      "application/octet-stream"
    )
      await fileService.downloadOctetFile(
        data.proposalDisbursementDocument.id,
        data.proposalDisbursementDocument.originalName
      );
    else await fileService.download(data.proposalDisbursementDocument.id);
  }

  get totalInMounth() {
    if (this.lastReport) {
      let startDate = this.lastReport.proposalStartDate as any;
      let endDate = this.lastReport.proposalEndDate as any;
      let periodMonth = Math.abs(moment(startDate).diff(endDate, "M"));
      periodMonth = Math.ceil(moment(endDate).diff(startDate, "month", true));
      return periodMonth;
    }
  }

  get balanceFinalBanco() {
    return this.lastReport
      ? this.lastReport.totalDisbursementAmount - this.lastReport.budgetExecuted
      : 0;
  }

  get totalElapsedInMounth() {
    if (
      this.lastReport &&
      String(this.lastReport.firstDisbursementDate) != "0001-01-01T00:00:00"
    ) {
      let startDate = this.lastReport.firstDisbursementDate as any;
      let endDate = new Date();
      let periodMonth = Math.abs(moment(startDate).diff(endDate, "M"));
      periodMonth = Math.ceil(moment(endDate).diff(startDate, "month", true));
      return periodMonth;
    }
    return 0;
  }

  get balanceAReembolsar() {
    return this.balanceFinalBanco < 0 ? this.balanceFinalBanco * -1 : 0;
  }

  totalProyecto() {
    for (let i = 0; i < this.lastReport.porposalBudgetItems.length; i++) {
      const item = this.lastReport.porposalBudgetItems[i];
      for (let y = 0; y < item.porposalBudgetSubItems.length; y++) {
        const subItem = item.porposalBudgetSubItems[y];
        for (
          let z = 0;
          z < subItem.porposalBudgetSubItemInstitutionDetails.length;
          z++
        ) {
          const detail = subItem.porposalBudgetSubItemInstitutionDetails[z];
          this.total.TotalGeneral += detail.amount;
          if (detail.isFondocyt) {
            this.total.FONDOCYT += detail.amount;
          } else {
            this.total.ContraPartida += detail.amount;
          }
        }
      }
    }
  }

  get totalSpent() {
    if (this.model && this.model.proposalBudgetItemsExecution) {
      return this.model.proposalBudgetItemsExecution.reduce((a, b) => {
        var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
          return c + d.amountSpent;
        }, 0);

        return a + result;
      }, 0);
    }
    return 0;
  }


  gotoReportsTable() {
    this.$router.push("/recived-reports-fondocyt");
  }

  async sendData() {
    if (
      this.file != null &&
      this.technicalScientistObservation &&
      this.financialCharacterObservation &&
      this.disbursement.amount > 0 &&
      this.disbursement.tradeNumber &&
      this.endProyectDate
    ) {
      this.$buefy.dialog.confirm({
        title: "Advertencia",
        type: "is-warning",
        size: "is-medium",
        hasIcon: true,
        confirmText: "Sí",
        cancelText: "No",
        message: "Al enviar este desembolso dara por concluido el proyecto.",
        onConfirm: () => this.confirmSave()
      });
    } else {
      this.operationNoAllowed("Debe llenar todos los campos");
    }
  }

  calculateTotalSpentByBudgetItem(row: ProposalBudgetItemExecution) {
    return row.proposalBudgetSubItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  async confirmSave() {
    this.showModal = false;
    this.loading = true;
    // disbursement
    let doc = await fileService.upload(this.file as File);
    doc.refEntityKey = "Id";
    doc.refEntityName = "ProposalDisbursement";
    this.disbursement.document = doc;
    this.disbursement.porposalId = this.lastReport.proposalId;
    let disbursmenteCreated = await this.proposalService.addPorposalDisbursement(
      this.disbursement
    );
    // report
    this.lastReport.closingBudget = this.presupuestoCierre;
    this.lastReport.technicalScientistObservation = this.technicalScientistObservation;
    this.lastReport.financialCharacterObservation = this.financialCharacterObservation;
    this.lastReport.state = ProposalState.AprobadoFC;
    this.lastReport.reason = null;
    this.lastReport.proposalDisbursementId = disbursmenteCreated.id;
    this.lastReport.proposalDisbursement = null;
    this.lastReport.endProyectDate = this.endProyectDate;
    await this.proposalService.addClosingBugetToProposal(
      this.lastReport.id,
      this.lastReport
    );
    await this.proposalService.updateProposalUserReport(
      this.lastReport.id,
      this.lastReport
    );
    this.wasEvaluated = true;
    this.getData();
    this.operationSuccess("Se ha aprobado el informe de manera exitosa");
    this.loading = false;
  }
}
